import { Icon } from '../../display/Icon';
import type { IconName } from '../../display/Icon';

import styles from './InteractiveTagIcon.module.scss';

export type InteractiveTagIconProps = {
  /**
   * Acessible attribute to hide the icon from screenreaders when the icon is purely decorative.
   * Optional since parent node can accept click events and the icon can have a aria-label.
   */
  'aria-hidden'?: boolean;
  /**
   * Aria label to be displayed for accessibility.
   */
  'aria-label'?: string;
  /**
   * The name of the icon to be rendered.
   */
  name: IconName;
  /**
   * The position of the icon inside the tag. It determines spacing inside the tag.
   */
  position: 'before' | 'after';
};

/**
 * Icon styled to be used inside of `InteractiveTag` or `InteractiveTag.Wrapper`.
 */
export const InteractiveTagIcon = ({
  'aria-hidden': ariaHidden = true,
  'aria-label': ariaLabel,
  name,
  position,
}: InteractiveTagIconProps) => {
  const calculateLeftMargin = () => {
    // Brings only the X icon closer to the left border.
    if (name === 'formX') {
      return position === 'before' ? '-5px' : '0px';
    }

    return '0px';
  };

  const calculateRightMargin = () => {
    // Brings only the X icon closer to the right border.
    if (name === 'formX') {
      return position === 'after' ? '-5px' : '0px';
    }

    return '0px';
  };

  return (
    <div
      className={styles.root}
      data-zds
      style={{
        '--_zds-interactive-tag-icon-margin-left': calculateLeftMargin(),
        '--_zds-interactive-tag-icon-margin-right': calculateRightMargin(),
      }}
    >
      <Icon
        aria-hidden={ariaHidden}
        aria-label={ariaLabel}
        name={name}
        size={24}
      />
    </div>
  );
};
